import ServiceCategoryPage from "../components/ServiceCategoryPage";
import geyserRepairService from "../data/services/geyserRepairService";

function GeyserRepair() {
  return <ServiceCategoryPage service={geyserRepairService} />;
}

export default GeyserRepair;